<template>
    <!--<v-toolbar fixed flat id="titleBar" :height=40 style="top:60px;">-->
    <v-toolbar fixed flat id="titleBar" :height="80" style="top:60px;">
        <!--<v-select dark v-model="select" :items="dropDownList" flat solo primary background-color="rgb(144,170,218)" style="height:120%; max-width:100px; margin-top:15px; margin-bottom:5px; font-size:14px;"></v-select>-->
        <v-select dark v-model="select" :items="dropDownList" flat solo primary background-color="rgb(144,170,218)" style="font-size:14px;"></v-select>
        <div style="display: flex">
            <div v-for="item in screenList" v-bind:key="item">
                <v-btn flat :ref="item" class="titleBtn" :class="{activeTitleBtn:item == activeTab}" v-on:click="navTo(item)"> {{item}}</v-btn>
            </div>
        </div>
        <!--<v-spacer/>-->
    </v-toolbar>
</template>

<script>
    import {store} from "../main.js"
    import {getData} from "../getData.js";

    var apiService;

    export default {
        name: 'Titlebar',
        components: {},
        props: {},
        created() {
            apiService = new getData();
        },
        mounted() {
            apiService.getRealAggrData();
        },
        data() {
            return {
                // breadCrumbList:['Dashboard'],
                dropDownList: ['Last Month', 'Last 3 Months', 'Last 6 Months', 'Last year'],
                screenList: ['Engines', 'Subsystems', 'Customers'],
                select: 'Last Month',
                placeholder: 'Last Month',
                activeTab: 'Engines'
            }
        },
        computed: {},
        watch: {
            select:function() {
                if (this.select != '') {
                    apiService.getRealAggrData(this.select);

                    this.placeholder = this.select;
                }
            },
        },
        methods: {
            navTo(screen) {
                this.activeTab = screen;
                this.$router.push({name: screen})
            },
        }
    }
</script>

<style scoped>
    #titleBar {
        background-color: rgb(244, 244, 244);
        padding: 0px;
        font-size: 18px;
        color: rgb(51, 82, 128);
    }

    .activeTitleBtn {
        color: rgb(51, 82, 128) !important;
        border-style: solid;
        border-color: rgb(51, 82, 128);
        border-width: 0px 0px 3px 0px;
    }
</style>

<style>
    .v-input__slot {
        min-height: 0px !important;
    }

    .alert {
        margin: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        width: 250px;
        height: 100px;
        background-color: white;
    }

    #titleBar .v-toolbar__content {
        display: block !important;
        padding: 0 !important;
    }

    #titleBar .v-input__control {
        min-height: initial !important;
    }

    #titleBar .v-input__slot {
        margin: 0 !important;
    }

    #titleBar .titleBtn {
        font-size: 12px !important;
        text-transform: none;

        display: inline-block;
        height: 100%;
        margin-right: 0px !important;
        margin-left: 0px !important;
    }
</style>
